import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from '@mui/material/Button';
import { Divider, Card, Layout, Col, Input, Space, Row, Typography, Alert, Result } from 'antd';
import {WarningSharp, SchoolRounded} from "@mui/icons-material";
import { fetchPortfolioPage } from "../../Api/publicApi";
import { fetchDetailedPortfolioObjects } from "../../Api/portfolioApi";
import { selectFullPortfolios } from "../../Store/slices/portfolios.slice";
import {Brand} from "../../Components/Brand";
import Disclaimer from "../../Components/Disclaimer";
import {default as BottomDisclaimer} from "../../Components/Disclaimer/Disclaimer";
import {markDisclaimerAsSeen, setEmail} from "../../Store/slices/public.slice";
import EmailEntry from "../../Components/EmailEntry";
import { GoogleCloudStorageBucketUrl } from '../../Configs/Domain';
import {fetchTouchpoints} from "../../Api/userApi";
import ContentViewer from "../../SuperComponents/ContentEditor/ContentViewer";
import PortfolioSquare  from "../Portfolio/PortfolioSquare";
import ThumbnailGrid from "../../Components/ThumbnailGrid/ThumbnailGrid";
import WidgetContainer from "../../Components/WidgetContainer";
import {filterAppsForUser} from "../../Configs/AppsConfig";


const PortfolioPagePublicEntrypoint = () => {
    const { pageId } = useParams();
    const dispatch = useDispatch();
    const disclaimerConfirmed = useSelector(state => state.public.disclaimerSeen);
    const email = useSelector(state => state.public.email);
    const portfolioPage = useSelector(state => state?.public?.portfolioPage);
    const portfolioIds = portfolioPage?.portfolio_ids;
    const touchpointIds = portfolioPage?.touchpoint_ids;
    const fullPortfolios = useSelector((state)=>selectFullPortfolios(state, portfolioIds||[]));
    const touchpoints = useSelector((state)=>state.public.touchpoints.filter(t=>touchpointIds.includes(t.id)));
    const loading = useSelector(state => state.public.loading);
    const error = useSelector(state => state.public.error);
    const files = portfolioPage?.files || [];
    const apps = portfolioPage?.apps || [];
    const filteredApps = apps.length > 0 && filterAppsForUser(apps, '/public');
    console.log(portfolioPage);
    console.log(touchpoints)

    useEffect(()=>{
        if (email){
            dispatch(fetchPortfolioPage({ pageId, email }));
        }
    }, [email])

    useEffect(()=>{
        if (portfolioIds){
            dispatch(fetchDetailedPortfolioObjects(portfolioIds));
        }
    }, [portfolioIds]);

    useEffect(()=>{
        if (touchpointIds){
            dispatch(fetchTouchpoints(touchpointIds));
        }
    }, [touchpointIds]);


    const handleEmailChange = (email) => {
        dispatch(setEmail(email));
    };

    const handleAgree = () => {
        dispatch(markDisclaimerAsSeen())
    }

    if (!disclaimerConfirmed) {
        return <Disclaimer onAgree={handleAgree} />;
    }
    if (!email){
        return (
            <div className={'p-6'} style={{maxWidth: '600px', margin: 'auto'}}>
                <Brand/>
                <Divider/>
                <EmailEntry onEmailSubmit={(email) =>handleEmailChange(email)} />
            </div>

        )
    }

    return (
        <Layout style={{
            background: '#fff',
            minHeight: '100vh',
        }}>
                <Row
                    className={'px-6'}
                    align={'middle'}
                    justify={'space-between'}
                    style={{
                        background: '#FFF',
                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                    }}
                >
                    <Brand maxHeight={'60px'} />
                    <Button
                        size={'large'}
                        variant={'contained'}
                        startIcon={<SchoolRounded/>}
                        onClick={()=>window.open('https://www.finiat.com')}
                    >
                        Learn More
                    </Button>
                </Row>
                <Divider/>
                <Layout.Content>
                    <Row wrap justify={'center'}>
                        <Col flex={'1'} offset={1} style={{padding: '10px 50px'}}>
                            <div className={'p-4'}
                                 style={{
                                    borderRadius: '4px',
                                    borderBottom: '1px dashed #ddd',
                                }}
                            >
                                <Typography.Title level={2} style={{color: "#000"}}>{portfolioPage?.title}</Typography.Title>
                                <Divider/>
                                {portfolioPage?.description?.length>0 && (
                                    <Typography.Text style={{color: "#000", fontFamily: "Georgia, serif", fontSize: '0.85rem', letterSpacing: '0.035em'}}>
                                        {portfolioPage?.description}
                                    </Typography.Text>
                                )}
                            </div>
                            <Divider/>
                            {portfolioPage && Array.isArray(fullPortfolios) && fullPortfolios.length>0 ? (
                                <Row>
                                    {fullPortfolios.map((portfolio, index) => (
                                        <PortfolioSquare
                                            key={index}
                                            portfolio={portfolio}

                                        />
                                    ))}
                                </Row>
                            ) : (
                                <Result
                                    icon={<WarningSharp color={'error'} style={{fontSize: '50px'}} />}
                                    status={'warning'}
                                    title={'No Portfolios Found'}
                                    subTitle={'This page may be inactive, you may not have permission, or there are no portfolios to display.'}
                                />
                            )}
                        </Col>
                        <Col flex={'0 0 400px'} offset={1}>
                            {
                                filteredApps && (<WidgetContainer widgets={filteredApps} />)
                            }
                            <Card bordered={false}>
                                <ThumbnailGrid files={files.map(file=>`${GoogleCloudStorageBucketUrl}${file}`)}
                                           direction={'column'}
                                           divider={files.length > 1 ? <Divider style={{borderBottom: '3px solid #ededed'}}/> : null}
                                />
                                {touchpoints&&touchpoints.length>0 && touchpoints.map((touchpoint, index) => (
                                    <ContentViewer key={index} contentData={touchpoint.content} />
                                ))}
                            </Card>
                        </Col>
                    </Row>

                </Layout.Content>
            <Layout.Footer
                    style={{
                        height: '100px',
                        bottom: 0,
                        backdropFilter: 'blur(10px)', padding: '20px'}}
                >
                    <BottomDisclaimer/>
            </Layout.Footer>

        </Layout>
    );
};

export default PortfolioPagePublicEntrypoint;
